/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthenticatedPnlRouteImport } from './routes/_authenticated/pnl'
import { Route as AuthenticatedBalance_sheetRouteImport } from './routes/_authenticated/balance_sheet'
import { Route as AuthenticatedIntegrationsIndexRouteImport } from './routes/_authenticated/integrations/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as PublicSlackInstallRouteImport } from './routes/_public/slack/install'
import { Route as AuthenticatedDashboardSlugRouteImport } from './routes/_authenticated/dashboard/$slug'
import { Route as PublicAOrgIdAgentIdRouteImport } from './routes/_public/a/$orgId/$agentId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedPnlRoute = AuthenticatedPnlRouteImport.update({
  id: '/pnl',
  path: '/pnl',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBalance_sheetRoute =
  AuthenticatedBalance_sheetRouteImport.update({
    id: '/balance_sheet',
    path: '/balance_sheet',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegrationsIndexRoute =
  AuthenticatedIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PublicSlackInstallRoute = PublicSlackInstallRouteImport.update({
  id: '/slack/install',
  path: '/slack/install',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedDashboardSlugRoute =
  AuthenticatedDashboardSlugRouteImport.update({
    id: '/dashboard/$slug',
    path: '/dashboard/$slug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PublicAOrgIdAgentIdRoute = PublicAOrgIdAgentIdRouteImport.update({
  id: '/a/$orgId/$agentId',
  path: '/a/$orgId/$agentId',
  getParentRoute: () => PublicRoute,
} as any)

export interface FileRoutesByFullPath {
  '/balance_sheet': typeof AuthenticatedBalance_sheetRoute
  '/pnl': typeof AuthenticatedPnlRoute
  '/login': typeof PublicLoginRoute
  '/signup': typeof PublicSignupRoute
  '/': typeof AuthenticatedIndexRoute
  '/dashboard/$slug': typeof AuthenticatedDashboardSlugRoute
  '/slack/install': typeof PublicSlackInstallRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexRoute
  '/a/$orgId/$agentId': typeof PublicAOrgIdAgentIdRoute
}
export interface FileRoutesByTo {
  '/balance_sheet': typeof AuthenticatedBalance_sheetRoute
  '/pnl': typeof AuthenticatedPnlRoute
  '/login': typeof PublicLoginRoute
  '/signup': typeof PublicSignupRoute
  '/': typeof AuthenticatedIndexRoute
  '/dashboard/$slug': typeof AuthenticatedDashboardSlugRoute
  '/slack/install': typeof PublicSlackInstallRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexRoute
  '/a/$orgId/$agentId': typeof PublicAOrgIdAgentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/balance_sheet': typeof AuthenticatedBalance_sheetRoute
  '/_authenticated/pnl': typeof AuthenticatedPnlRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/dashboard/$slug': typeof AuthenticatedDashboardSlugRoute
  '/_public/slack/install': typeof PublicSlackInstallRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/_public/a/$orgId/$agentId': typeof PublicAOrgIdAgentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/balance_sheet'
    | '/pnl'
    | '/login'
    | '/signup'
    | '/'
    | '/dashboard/$slug'
    | '/slack/install'
    | '/dashboard'
    | '/integrations'
    | '/a/$orgId/$agentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/balance_sheet'
    | '/pnl'
    | '/login'
    | '/signup'
    | '/'
    | '/dashboard/$slug'
    | '/slack/install'
    | '/dashboard'
    | '/integrations'
    | '/a/$orgId/$agentId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/balance_sheet'
    | '/_authenticated/pnl'
    | '/_public/login'
    | '/_public/signup'
    | '/_authenticated/'
    | '/_authenticated/dashboard/$slug'
    | '/_public/slack/install'
    | '/_authenticated/dashboard/'
    | '/_authenticated/integrations/'
    | '/_public/a/$orgId/$agentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/pnl': {
      id: '/_authenticated/pnl'
      path: '/pnl'
      fullPath: '/pnl'
      preLoaderRoute: typeof AuthenticatedPnlRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/balance_sheet': {
      id: '/_authenticated/balance_sheet'
      path: '/balance_sheet'
      fullPath: '/balance_sheet'
      preLoaderRoute: typeof AuthenticatedBalance_sheetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations/': {
      id: '/_authenticated/integrations/'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/slack/install': {
      id: '/_public/slack/install'
      path: '/slack/install'
      fullPath: '/slack/install'
      preLoaderRoute: typeof PublicSlackInstallRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/dashboard/$slug': {
      id: '/_authenticated/dashboard/$slug'
      path: '/dashboard/$slug'
      fullPath: '/dashboard/$slug'
      preLoaderRoute: typeof AuthenticatedDashboardSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/a/$orgId/$agentId': {
      id: '/_public/a/$orgId/$agentId'
      path: '/a/$orgId/$agentId'
      fullPath: '/a/$orgId/$agentId'
      preLoaderRoute: typeof PublicAOrgIdAgentIdRouteImport
      parentRoute: typeof PublicRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedBalance_sheetRoute: typeof AuthenticatedBalance_sheetRoute
  AuthenticatedPnlRoute: typeof AuthenticatedPnlRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedDashboardSlugRoute: typeof AuthenticatedDashboardSlugRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedIntegrationsIndexRoute: typeof AuthenticatedIntegrationsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBalance_sheetRoute: AuthenticatedBalance_sheetRoute,
  AuthenticatedPnlRoute: AuthenticatedPnlRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedDashboardSlugRoute: AuthenticatedDashboardSlugRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedIntegrationsIndexRoute: AuthenticatedIntegrationsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicSignupRoute: typeof PublicSignupRoute
  PublicSlackInstallRoute: typeof PublicSlackInstallRoute
  PublicAOrgIdAgentIdRoute: typeof PublicAOrgIdAgentIdRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicSignupRoute: PublicSignupRoute,
  PublicSlackInstallRoute: PublicSlackInstallRoute,
  PublicAOrgIdAgentIdRoute: PublicAOrgIdAgentIdRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
